import { ExerciseCategoryDto } from '../../../../shared/dtos/exerciseCategory.dto';
import { ExerciseTagDto } from '../../../../shared/dtos/exerciseTag.dto';
import { FC, ReactElement, ReactNode } from 'react';
import i18next from 'i18next';
import DataTable, { DataTableColumn } from '../data-table/DataTable';
import StatusBadge from '../data-table/StatusBadge';

type ExerciseTagsTableProps = {
  tags: ExerciseTagDto[];
  categories: ExerciseCategoryDto[];
  isLoading: boolean;
  toolbar?: ReactNode;
  onClick?: (tag: ExerciseTagDto) => void;
}

const ExerciseTagTable: FC<ExerciseTagsTableProps> = ({
  tags,
  categories,
  isLoading,
  toolbar,
  onClick,
}: ExerciseTagsTableProps): ReactElement => {
  const columns: DataTableColumn<ExerciseTagDto>[] = [
    {
      key: 'germanTitle',
      header: i18next.t('exerciseTag.germanTitle'),
      cell: (tag: ExerciseTagDto) => <span className="fw-semibold">{tag.de}</span>,
    },
    {
      key: 'englishTitle',
      header: i18next.t('exerciseTag.englishTitle'),
      cell: (tag: ExerciseTagDto) => <span className="text-muted">{tag.en}</span>,
    },
    {
      key: 'category',
      header: i18next.t('exerciseTag.category'),
      cell: (tag: ExerciseTagDto) => categories.find((category: ExerciseCategoryDto) => category.id === tag.categoryId)?.de,
    },
    {
      key: 'isActive',
      header: i18next.t('exerciseTag.isActive'),
      cell: (tag: ExerciseTagDto) => (
        <StatusBadge
          isActive={tag.isActive}
          label={i18next.t(tag.isActive ? 'exerciseTag.active' : 'exerciseTag.notActive')}
        />
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={tags}
      rowKey={(tag: ExerciseTagDto) => tag.id}
      onRowClick={onClick}
      isLoading={isLoading}
      toolbar={toolbar}
    />
  );
};

export default ExerciseTagTable;
